import React from 'react';
import { FrameBone, ParagraphBone } from '@gik/ui';
import repeatElement from '@gik/core/utils/repeatElement';
import { useRandomInt } from '@gik/core/utils/getRandomInt';
import bemBlock from '@gik/core/utils/bemBlock';

export default function SavedProductsListSkeleton() {
  const bem = bemBlock('saved-products-list-skeleton');
  const repeat = useRandomInt(2, 6);

  return (
    <div className={bem()}>
      <section className={bem('items')}>
        {repeatElement(
          repeat,
          <FrameBone className={bem('item')}>
            <ParagraphBone words={useRandomInt(3, 7)} />
          </FrameBone>
        )}
      </section>
    </div>
  );
}
